import React, { Fragment, useState } from 'react';
import config from '../../../../config';
import '../styles/index.css';
import { RiDoubleQuotesL, RiDoubleQuotesR } from 'react-icons/ri';

export default function TestimoinalVideoItem({ data, variant }) {
  const { id, img, name, country, flag, socialIcon, video, thumbnail, description, videoDescription, profession, certificateSrc } = data;
  const cloudFront = config.cloudFront;
  const [videoRendering, setVideoRendering] = useState(0);

  const playTestimonial = () => {
    let TestimonialThumbail = document.getElementById(`tstmnl-thumbnail-${id}`);
    let TestimonialPlayIcon = document.getElementById(`tstmnl-play-icon-${id}`);
    TestimonialThumbail.style.display = 'none';
    setVideoRendering(id);

    setTimeout(() => {
      let TestimonialVideo = document.getElementById(`testimonial-video-${id}`);
      if (TestimonialVideo.paused) {
        TestimonialPlayIcon.style.display = 'none';
        TestimonialVideo.play();
      } else {
        TestimonialPlayIcon.style.display = 'unset';
        TestimonialVideo.pause();
      }
    }, 100);
  };

  return (
    <Fragment>
      <div className="w-100 video-tstmnl-card">
        <div className="tstmnl-video-thumbnail-wrapper">
          <div className="tstmnl-thumbnail-container" id={`tstmnl-thumbnail-${id}`} onClick={() => playTestimonial()}>
            <img className="testimonial-thumbnail" src={cloudFront + thumbnail} alt={`Reviewer ${id} thumbnail`} />
          </div>

          {videoRendering === id && (
            <div className="tstmnl-video-container">
              <video
                className="testimonial-video"
                id={`testimonial-video-${id}`}
                src={cloudFront + video}
                poster={cloudFront + thumbnail}
                onClick={() => playTestimonial()}
              ></video>
            </div>
          )}

          {/*{variant === 'partner-plus' ? (
            <img className="tstmnl-play-icon no-pointers" id={`tstmnl-play-icon-${id}`} src={cloudFront + '/Assets/PartnerPlus/partnerTestimonialPlayicon.svg'} alt="" />
          ) : variant === 'regionals' ? (
            <img className="tstmnl-play-icon no-pointers" id={`tstmnl-play-icon-${id}`} src={cloudFront + '/Assets/Regionals/regionalsTestimonialPlayicon.svg'} alt="" />
          ) : variant === 'code-juniors' ? (
            <img className="tstmnl-play-icon no-pointers" id={`tstmnl-play-icon-${id}`} src={cloudFront + '/Assets/Juniors/juniorsTestimonialPlayicon.svg'} alt="" />
          ) : (
          )}*/}
          <img className="tstmnl-play-icon no-pointers" id={`tstmnl-play-icon-${id}`} src={cloudFront + '/Assets/IconsPack/testimonialPlayicon.svg'} alt="" />
        </div>

        <div className="tstmnl-video-txt-wrapper">
          <p className="tstmnl-video-desc-txt">
            <sup>
              <RiDoubleQuotesL style={{ fontSize: '1.75em' }} />
            </sup>
            {videoDescription}
            <sub>
              <RiDoubleQuotesR style={{ fontSize: '1.75em' }} />
            </sub>
          </p>

          <p className="tstmnl-video-head-text text-dark headingFont weight-500 text-right pt-1 pt-xl-2">- {name}</p>
        </div>
      </div>
    </Fragment>
  );
}
